import { Component, OnInit } from '@angular/core';
import { VwoService } from '../../../shared/services';
import { HomepageService } from '../../services/homepage.service';
import { UtilService } from './../../../shared/services/util/util.service';
@Component({
  selector: 'app-trending-fundraiers',
  templateUrl: './trending-fundraiers.component.html',
  styleUrls: ['./trending-fundraiers.component.scss']
})
export class TrendingFundraiersComponent implements OnInit {
  breakpoints = {
    600: { perView: 1.1, showArrows: false, gap: 15 },
    992: { perView: 2, focusAt: 0 }
  };
  trendingFr = [];
  currency;
  widgetsInView;

  constructor(
    private homepageService: HomepageService,
    private utilService: UtilService,
    public vwo: VwoService
  ) { }

  ngOnInit() {
    if (this.utilService.isBrowser) {
      this.getCurrency();
    } else {
      this.trendingFr = [];
    }
  }

  getTrendingFr(currency) {
    this.trendingFr = [];
    const qparams = '&with=basicInfo';
    this.homepageService.getTrendingFR(currency, qparams).subscribe((res: any) => {
      this.trendingFr = res.data.data;
    });
  }

  /**
   * Get the currency of the from
   * currency observable
  */
  getCurrency() {
    this.utilService.currency.subscribe((res) => {
      if (res) {
        this.currency = res;
        this.getTrendingFr(res);
      }
    });
  }
}
